import React, { useState } from "react";
import classNames from "classnames";
import get from "lodash/get";
import { useParams } from "next/navigation";

// components
import ShowMapButton from "./ShowMapButton";
import Button from "@/shared/Button";
import Dropdown, { DropdownMenuItemProps } from "@/shared/Dropdown";
import SaveSearchModal from "@/components/Modals/SaveSearchModal";

// helpers
import { SORT_BY_OPTIONS } from "../helpers";
import { useDimension } from "@/hooks/useDimensions";
import useQueryParams from "@/hooks/useQueryParams";
import { useLockoutModalContext } from "@/contexts/LockoutModalContext";
import customDataLayerPush from "@/helpers/customDataLayerPush";

// interfaces
import { ISearchResultsControls } from "../ISearchResultsPageComponent";

// assets
import styles from "@/assets/styles/pages/search-results.module.scss";


function SearchResultsControls({ isAuthorized, searchResults, showMap, toggleMapView }: ISearchResultsControls) {
  const [saveSearchOpened, setSaveSearchOpened] = useState(false);

  const { setState } = useLockoutModalContext();
  const [queryParams, setQueryParams] = useQueryParams();
  const [width] = useDimension();
  const { lang } = useParams();

  const defaultOrderingValue = lang === "aus" ? SORT_BY_OPTIONS.find(item => item.value === "-weekly_footfall") : SORT_BY_OPTIONS[0];

  // methods
  const onSaveSearchClick = () => {
    if (isAuthorized) {
      setSaveSearchOpened(true);

      return;
    }

    setState({ open: true });
    customDataLayerPush("lo_fo_modal_popup_shown", null, { lofo_type: "soft lofo" });
  };

  return (
    <div className={styles["locl-search-results__cards__controls__wrap"]}>
      <div className={classNames(styles["locl-search-results__cards__controls"], styles["locl-search-results__cards__controls-order"])}>
        <Dropdown
          menu={{ items: SORT_BY_OPTIONS }}
          onChange={e => setQueryParams({ ordering: (e as DropdownMenuItemProps).value })}
          value={SORT_BY_OPTIONS.find(el => el.value === queryParams.ordering) || defaultOrderingValue}
          placeholder="Sort by"
          buttonProps={{ "data-testid": "locl-sort-by-dropdown", disabled: false }}
        />
      </div>
      <div className={styles["locl-search-results__cards__controls"]}>
        <Button
          type="secondary"
          fullWidth={width < 620}
          onClick={onSaveSearchClick}
          data-testid="locl-save-search-button"
        >
        Save search
        </Button>
        {get(searchResults, "results.length", 0) > 0 && (
          <ShowMapButton
            fullWidth={width < 620}
            isMapShown={showMap}
            onClick={toggleMapView}
            data-testid="locl-show-map-button"
          />
        )}
      </div>
      <SaveSearchModal
        title="Save your search"
        open={saveSearchOpened}
        onCancel={() => setSaveSearchOpened(!saveSearchOpened)}
      />
    </div>
  );
}

export default SearchResultsControls;
